export const URLS = {
    MARKET_URL: `https://www.wildberries.ru/brands/2728337-Flytrox`,
    SNIPE_URL: `https://www.wildberries.ru/catalog/94334495/detail.aspx?targetUrl=BP`,
    SWIFT_URL: `https://www.wildberries.ru/catalog/94336079/detail.aspx?targetUrl=BP`,
    STORK_URL: `https://www.wildberries.ru/catalog/138167093/detail.aspx?targetUrl=GP`
}
